import p from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  background-color: var(--spectrum-global-color-gray-50);
  height: 100%;
  box-shadow: 0 3px 0px rgba(0, 0, 0, 0.05);
  justify-content: center;
  z-index: 2;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  padding: 8px 0;
  width: 100%;
  & > div {
    max-width: 1440px;
  }
`;

/**
 * Styled header container using spectrum variables.
 */
const PropsContainer = (props) => <HeaderContainer {...props}>{props.children}</HeaderContainer>;

PropsContainer.propTypes = {
  /** Set to true if the element is displayed in a single column format */
  $isSingleColumn: p.bool,
};

PropsContainer.defaultProps = {
  $isSingleColumn: false,
};

export default PropsContainer;
